import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ActivitySubscriptionType } from '@recruitee/activities-types';
import type {
  ActivitySubscriptions,
  ActivitySubscriptionUpdateData,
} from '@recruitee/activities-types';
import { TranslatePipe } from '@recruitee/i18n';

import { ActivitySubscriptionsTableRowComponent } from '../activity-subscriptions-table/activity-subscriptions-table-row/activity-subscriptions-table-row.component';
import { ActivitySubscriptionsTableComponent } from '../activity-subscriptions-table/activity-subscriptions-table.component';

@Component({
  selector: 'rt-activity-subscriptions-followed-requisitions',
  templateUrl: './activity-subscriptions-followed-requisitions.component.html',
  styleUrls: ['../activity-subscriptions.less'],
  standalone: true,
  imports: [
    ActivitySubscriptionsTableComponent,
    TranslatePipe,
    ActivitySubscriptionsTableRowComponent,
  ],
})
export class ActivitySubscriptionsFollowedRequisitionsComponent {
  @Input() public types: ActivitySubscriptionType[];
  @Input() public activitySubscriptions: ActivitySubscriptions;
  @Output() public changeEvents: EventEmitter<ActivitySubscriptionUpdateData> = new EventEmitter();
}
